var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{style:(("height: " + _vm.height + ";"))},[_c('TransitionLogo',{attrs:{"size":_vm.size,"text":_vm.text}}),_c('ArrowButton',{staticClass:"arrow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }